/* hs-eslint ignored failing-rules */
/* eslint-disable react-hooks/exhaustive-deps */

'use es6';

import { useState, useEffect, useRef } from 'react';
import merge from 'hs-lodash/merge';
import styled, { ThemeProvider } from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'quartz-routing/react-router';
import usageTracker from '../../lib/usageTracker';
import ChecklistPage from './ChecklistPage';
import LoadingPage from './LoadingPage';
import MobilePage from './MobilePage';
import OverallPage from './OverallPage';
import PerformancePage from './PerformancePage';
import SecurityPage from './SecurityPage';
import SeoPage from './SeoPage';
import WidgetResultsCta from './WidgetResultsCta';
import OverallGrade from '../sidepanel/OverallGrade';
import GraderActionCreator from '../../actions/GraderActionCreator';
import PreviewActionCreator from '../../actions/PreviewActionCreator';
import Logo from '../Logo';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getWebsiteGrade } from '../../selectors/Grader';
import TwoColumnLayout from '../layouts/TwoColumnLayout';
import { defaultTheme } from '../../theming/themes/default';
import { colors } from '../../theming/themes/colors';
import ctaBlob from 'bender-url!../../../img/cta-blobs.png';
import useWindowPostMessage from '../../hooks/useWindowPostMessage';
import LanguageSwitcher from '../LanguageSwitcher';
import get from 'hs-lodash/get';
import isString from 'hs-lodash/isString';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const WidgetTrialCTAPageWrapper = styled.div.withConfig({
  displayName: "WidgetResultsPage__WidgetTrialCTAPageWrapper"
})(["background:url(", ") right bottom no-repeat;background-color:", ";color:", ";text-align:left;font-size:16px;"], ctaBlob, colors.PICKLEDBLUEWOODALT, colors.PRIMARYWHITE);
const HeaderToolbarWrapper = styled.div.withConfig({
  displayName: "WidgetResultsPage__HeaderToolbarWrapper"
})(["position:absolute;top:0;width:100%;margin-top:40px;& > div{display:flex;justify-content:center;flex-direction:row;align-content:stretch;flex-wrap:nowrap;align-items:center;}& a{margin:0 1em;padding:0;color:", ";}"], colors.PRIMARYWHITE);
const FooterToolbarWrapper = styled.div.withConfig({
  displayName: "WidgetResultsPage__FooterToolbarWrapper"
})(["height:200px;display:flex;flex-direction:row;align-items:baseline;justify-content:center;margin:auto;padding:50px 0 50px 0;"]);
const ShareBanner = ({
  config = {},
  onIconClick = () => undefined
}) => {
  const noSocialShareConfigured = config && !config.twitter && !config.linkedin && !config.facebook && !config.email;
  if (noSocialShareConfigured) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: "share-banner",
    children: /*#__PURE__*/_jsxs("div", {
      className: "share-banner-content",
      children: [/*#__PURE__*/_jsxs("span", {
        className: "share-banner-header",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "results.share.banner.title"
        }), /*#__PURE__*/_jsx("span", {
          className: "share-banner-paragraph",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "results.share.banner.description"
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "share-banner-buttons",
        children: /*#__PURE__*/_jsxs("div", {
          className: "share-icons",
          children: [config.twitter && /*#__PURE__*/_jsx("a", {
            className: "icon icon-twitter",
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: () => onIconClick('twitter')
          }), config.facebook && /*#__PURE__*/_jsx("a", {
            className: "icon icon-facebook",
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: () => onIconClick('facebook')
          }), config.linkedin && /*#__PURE__*/_jsx("a", {
            className: "icon icon-linkedin",
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: () => onIconClick('linkedin')
          }), config.linkedin && /*#__PURE__*/_jsx("a", {
            className: "icon icon-email",
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: () => onIconClick('email')
          })]
        })
      })]
    })
  });
};
const derivedTheme = config => {
  if (!config) return defaultTheme;
  const theme = {};
  const resultsPage = {};
  if (config.logo) {
    theme.logo = {
      url: config.logo
    };
  }
  if (config.title) {
    theme.title = config.title;
  }
  if (config.resultLinearGradient && config.resultLinearGradient.angle && config.resultLinearGradient.colorStop1 && config.resultLinearGradient.colorStop2) {
    const {
      angle,
      colorStop1,
      colorStop2
    } = config.resultLinearGradient;
    resultsPage.overallResults = {
      background: `linear-gradient(${angle}deg, ${colorStop1} 0%, ${colorStop2} 80%)`
    };
  }
  if (config.footerLinks) {
    theme.footerLinks = config.footerLinks;
  }
  if (config.headerLinks) {
    theme.headerLinks = config.headerLinks;
  }
  return merge({}, defaultTheme, theme, {
    resultsPage
  });
};
const HeaderLinks = ({
  config = []
}) => {
  return /*#__PURE__*/_jsx(HeaderToolbarWrapper, {
    children: /*#__PURE__*/_jsx("div", {
      children: config.map((item, i) => /*#__PURE__*/_jsx("a", {
        href: item.url,
        target: "_blank",
        rel: "noopener noreferrer",
        children: item.name
      }, i))
    })
  });
};
const FooterLinks = ({
  config = []
}) => {
  return /*#__PURE__*/_jsx(FooterToolbarWrapper, {
    children: config.map((item, i) => /*#__PURE__*/_jsx("a", {
      className: "button white",
      href: item.url,
      target: "_blank",
      rel: "noopener noreferrer",
      children: item.name
    }, i))
  });
};
const usePostMessageHandling = ({
  websiteGrade
}) => {
  const gradesRef = useRef(websiteGrade);
  const [config, setConfig] = useState();
  const [postMessage] = useWindowPostMessage(({
    data
  }) => {
    switch (data.type) {
      case 'GRADER_STYLE_UPDATE':
        {
          setConfig(data.payload);
          postMessage({
            type: 'GRADER_STYLE_UPDATE_APPLIED'
          });
          return;
        }
      case 'GRADER_REQUEST_RESULTS':
        postMessage({
          type: 'GRADER_RESULTS',
          payload: gradesRef.current
        });
        return;
      default:
        return;
    }
  });
  useEffect(() => {
    gradesRef.current = websiteGrade;
  }, [websiteGrade]);
  useEffect(() => {
    postMessage({
      type: 'GRADER_LOADED'
    });
  }, []);
  useEffect(() => {
    // tell the parent the grades are ready and send the grades
    if (!websiteGrade.loading) postMessage({
      type: 'GRADER_GRADES_READY'
    });
  }, [websiteGrade.loading]);
  const onSocialShareClicked = social => postMessage({
    type: 'GRADER_SOCIAL_SHARE_CLICKED',
    payload: {
      social,
      language: window.I18N_MANUAL_LANG
    }
  });
  const onCtaClicked = () => postMessage({
    type: 'GRADER_CTA_CLICKED'
  });
  return {
    config,
    onSocialShareClicked,
    onCtaClicked
  };
};
const WidgetHeaderToolbar = ({
  toolbar
}) => /*#__PURE__*/_jsxs("div", {
  className: "main-toolbar",
  children: [/*#__PURE__*/_jsx("div", {
    className: "logo-left",
    children: /*#__PURE__*/_jsx(Logo, {})
  }), toolbar, /*#__PURE__*/_jsx(LanguageSwitcher, {})]
});
const Results = ({
  websiteGrade,
  config,
  onSocialShareClicked,
  onCtaClicked
}) => {
  const show = get(config, 'sidepanelCta.show', false);
  const agency = get(config, 'sidepanelCta.agency');
  const showCta = show && isString(agency);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "WIDGET_RESULTS_PAGE_LOADED"
    }), /*#__PURE__*/_jsx(TwoColumnLayout, {
      "data-test-id": "results-page",
      leftContent: /*#__PURE__*/_jsx(OverallGrade, {
        websiteGrade: websiteGrade,
        ctaSection: showCta && /*#__PURE__*/_jsx(WidgetResultsCta, {
          agency: agency,
          onClick: onCtaClicked
        })
      }),
      rightContent: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(WidgetHeaderToolbar, {
          toolbar: /*#__PURE__*/_jsx(HeaderLinks, {
            config: config && config.headerLinks
          })
        }), /*#__PURE__*/_jsx(OverallPage, {
          websiteGrade: websiteGrade,
          hideCTAs: true
        }), /*#__PURE__*/_jsx(PerformancePage, {
          websiteGrade: websiteGrade,
          hideCTAs: true
        }), /*#__PURE__*/_jsx(SeoPage, {
          websiteGrade: websiteGrade,
          hideCTAs: true
        }), /*#__PURE__*/_jsx(MobilePage, {
          websiteGrade: websiteGrade,
          hideCTAs: true
        }), /*#__PURE__*/_jsx(SecurityPage, {
          websiteGrade: websiteGrade,
          hideCTAs: true
        }), /*#__PURE__*/_jsx(ChecklistPage, {
          websiteGrade: websiteGrade,
          hideCTAs: true
        }), /*#__PURE__*/_jsx(ShareBanner, {
          config: config && config.socialLinks,
          onIconClick: onSocialShareClicked
        }), /*#__PURE__*/_jsx(WidgetTrialCTAPageWrapper, {
          children: /*#__PURE__*/_jsx(FooterLinks, {
            config: config && config.footerLinks
          })
        })]
      })
    })]
  });
};
const WidgetResultsPage = () => {
  const dispatch = useDispatch();
  const websiteGrade = useSelector(getWebsiteGrade);
  const {
    websiteUrl
  } = useParams();
  const loadWebsiteGrade = () => {
    dispatch(GraderActionCreator.getGrade(websiteUrl));
    dispatch(PreviewActionCreator.previewWebsite(websiteUrl));
  };
  const {
    config,
    onSocialShareClicked,
    onCtaClicked
  } = usePostMessageHandling({
    websiteGrade
  });
  const theme = derivedTheme(config);
  useEffect(() => {
    usageTracker.logView('Results', {
      theme: theme.name
    });
    loadWebsiteGrade();
    return () => dispatch(GraderActionCreator.resultsPageUnmounted());
  }, []);
  const renderLoading = () => {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "WIDGET_GRADING_IN_PROGRESS"
      }), /*#__PURE__*/_jsx(LoadingPage, {
        websiteUrl: websiteUrl
      })]
    });
  };
  const renderResults = () => {
    return /*#__PURE__*/_jsx(Results, {
      websiteGrade: websiteGrade,
      config: config,
      onSocialShareClicked: onSocialShareClicked,
      onCtaClicked: onCtaClicked
    });
  };
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: theme,
    children: websiteGrade.loading ? renderLoading() : renderResults()
  });
};
export default WidgetResultsPage;